import { render, staticRenderFns } from "./IMTableHeader.vue?vue&type=template&id=172e601f&scoped=true&"
import script from "./IMTableHeader.vue?vue&type=script&lang=js&"
export * from "./IMTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./IMTableHeader.vue?vue&type=style&index=0&id=172e601f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e601f",
  null
  
)

export default component.exports